<template>
  <!-- 问题答疑 -->
   <div class="faq-content">
      <div class="faq">
        <img :src="isMaxScreen ? item.image1 : item.image" alt="" v-for="(item,index) in imgList">
      </div>
   </div>
 </template>
 
 <script>
 import { mapState } from 'vuex';
 export default {
   name: 'faq',
   data () {
     return {
      imgList: [
        {
          image: require('../assets/image/faq/FAQ01.png'),
          image1: require('../assets/image/faq/P_FAQ01.png'),
        },
        {
          image: require('../assets/image/faq/FAQ02.png'),
          image1: require('../assets/image/faq/P_FAQ02.png'),
        },
        {
          image: require('../assets/image/faq/FAQ03.png'),
          image1: require('../assets/image/faq/P_FAQ03.png'),
        },
        {
          image: require('../assets/image/faq/FAQ04.png'),
          image1: require('../assets/image/faq/P_FAQ04.png'),
        }
      ]
     };
   },
   props: {
   },
   computed: {
     ...mapState({
       isMaxScreen: state => state.isMaxScreen
     })
   },
   methods: {
   }
 };
 </script>
 
 <style lang="less" scoped>
    @media (max-width: 980px) {
      .faq-content{
        width: 654px;
        margin: 70px auto 0;
      }
      img{
        width: 100%;
        margin-bottom: 60px;
      }
    }

    @media (min-width: 981px) {
      .faq{
        display: flex;
        flex-direction: column;
        padding-top: 80px;
      }
      .faq-content{
        background-color: #fff;
      }
      img{
        width: 1200px;
        margin: 0px auto 60px;
      }
    }
 </style>
 